import { DocumentationFile } from '../../../graphql/graphql';
import { PreviewFile } from '../../Utils/MediaViewer/MediaViewer';

export const prepareDocumentationFileForMediaViewer = (
	item: DocumentationFile,
	socketUrl: string,
) => {
	const imageExtensions = ['jpg', 'jpeg', 'png', 'gif'];
	const fileType =
		imageExtensions.indexOf(item?.file?.extension ?? '') !== -1
			? 'image'
			: item?.file?.extension === 'pdf'
			? 'pdf'
			: 'none';
	return {
		id: item.file?.id,
		name: item.name,
		displayName: item.name,
		type: fileType,
		preview:
			socketUrl +
			'/patients/' +
			item.userId +
			'/documentation/' +
			item.folderId +
			'/' +
			item.id +
			'/preview',
		download:
			socketUrl +
			'/patients/' +
			item.userId +
			'/documentation/' +
			item.folderId +
			'/' +
			item.id +
			'?download=1',
	} as PreviewFile;
};
